import React from "react";

interface Props { }

export const VolumeMutedIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6L12 0V24L6 18H0V6H6Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M18.9407 9.87869L21.88 6.93935L24.0013 9.06067L21.062 12L24.0013 14.9394L21.88 17.0607L18.9407 14.1213L16.0013 17.0607L13.88 14.9394L16.8193 12L13.88 9.06067L16.0013 6.93935L18.9407 9.87869Z"/>
    </svg>
    // tslint:enable:max-line-length
  );
};
